import setNestedValue from '@/services/functions/setNestedValue'
/**
 * Envuelve un valor primitivo.
 * @template {string|number|boolean|symbol} T
 */
export default class PrimitiveOptionWrapper {
    /** @type {T} */
    value
    /**
     * @param {T} value
     * @param {string} path
     */
    constructor (value, path) {
      this.value = value
      if (path && path !== 'value' && path !== '.') {
        setNestedValue(path, this, value)
      }
    }
}
